import * as Icons from "@material-ui/icons";

import { Menu as FobMenu, MenuGroup, MenuItem } from "ra-friendsofbabba";
import React, { Fragment, useMemo } from "react";
import { usePermissions, useQuery, useTranslate } from "react-admin";

import { APP_URL } from "../config";

const MenuContentGroup = ({
  translate,
  open,
  location,
  onMenuClick,
  menu,
  filter,
}) => {
  const groups = useMemo(() => menu.filter((g) => filter(g)), [menu, filter]);
  return groups.map((group, idx) => (
    <MenuGroup
      key={idx}
      open={open}
      label={translate(`menu.groups.${group.label}`)}
    >
      {group.items.map((item, index) => (
        <MenuItem
          {...item}
          key={index}
          open={open}
          location={location}
          onMenuClick={onMenuClick}
        />
      ))}
    </MenuGroup>
  ));
};
const MenuContent = ({
  menu,
  open,
  location,
  onMenuClick,
  translate,
  isAdmin,
}) => (
  <Fragment>
    <MenuContentGroup
      menu={menu}
      open={open}
      translate={translate}
      location={location}
      onMenuClick={onMenuClick}
      filter={(g) => g.label !== "admin"}
    />

    <MenuContentGroup
      menu={menu}
      open={open}
      translate={translate}
      location={location}
      onMenuClick={onMenuClick}
      filter={(g) => g.label === "admin"}
    />
  </Fragment>
);

const Menu = (props) => {
  const translate = useTranslate();
  const { data: pages } = useQuery({
    resource: "pages/menu",
    type: "get",
  });
  const { data: badges } = useQuery({
    resource: "stats/badges",
    type: "get",
  });
  const { permissions } = usePermissions();
  const isAdmin = useMemo(
    () => permissions && permissions(["admin"]),
    [permissions]
  );

  return (
    <FobMenu
      {...props}
      mode="custom"
      order={{
        dashboard: 10,

        admin: 100,
        pages: 10,
      }}
      items={pages?.data?.map((page) => ({
        name: page.name,
        path: `/pages/${page.id}/show`,
        label: page.name,
        icon: Icons.Info,
        group: "pages",
        localize: false,
      }))}
      badges={badges?.data}
    >
      <MenuContent {...props} translate={translate} isAdmin={isAdmin} />

      <MenuGroup label={translate("menu.groups.contacts")}>
        <MenuItem
          icon={Icons.Email}
          label={translate("menu.items.contact_tech")}
          sub={translate("menu.items.contact_tech.help")}
          href="mailto:assistenza@refin.regione.puglia.it"
        />
      </MenuGroup>
      <MenuGroup label={translate("menu.groups.download")}>
        <MenuItem
          icon={Icons.MenuBook}
          label={translate("menu.items.vademecum")}
          sub={translate("menu.items.vademecum.help")}
          href={`${APP_URL}/assets/VademecumIIIAnno.pdf`}
        />
        <MenuItem
          icon={Icons.PlayCircleOutline}
          label={translate("menu.items.presentation")}
          sub={translate("menu.items.presentation.help")}
          href={`${APP_URL}/assets/TemplatePIIAnno.pptx`}
        />
        <MenuItem
          icon={Icons.TableChart}
          label={translate("menu.items.technical_report_schema")}
          sub={translate("menu.items.technical_report_schema.help")}
          href={`${APP_URL}/assets/TemplateRTFIIIAnno.docx`}
        />
        <MenuItem
          icon={Icons.TableChart}
          label={translate("menu.items.technical_report_eval_schema")}
          sub={translate("menu.items.technical_report_eval_schema.help")}
          href={`${APP_URL}/assets/TemplateSVIIIAnno.docx`}
        />
      </MenuGroup>
    </FobMenu>
  );
};

export default Menu;
